import { ComponentType, ExoticComponent, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { Spinner } from "@bps/fluent-ui";

interface ModuleRoute {
  path: string;
  resolveComponent: () => Promise<{ default: ComponentType }>;
}

const modules: ModuleRoute[] = [
  {
    path: "/tenants/*",
    resolveComponent: () => import("../tenants")
  },
  {
    path: "/users/*",
    resolveComponent: () => import("../users")
  },
  {
    path: "/system/*",
    resolveComponent: () => import("../system")
  },
  {
    path: "/field-mgmt/*",
    resolveComponent: () => import("../field-mgmt")
  },
  {
    path: "/cam/*",
    resolveComponent: () => import("../cam")
  }
];

interface LazyModuleProps {
  component: ExoticComponent;
}

const LazyModule = ({ component: Component }: LazyModuleProps) => {
  return <Component />;
};

export const AppRoutes = () => {
  return (
    <Suspense fallback={<Spinner>Loading, please wait...</Spinner>}>
      <Routes>
        {modules.map(({ path, resolveComponent }) => (
          <Route
            key={path}
            path={path}
            element={<LazyModule component={lazy(resolveComponent)} />}
          />
        ))}

        <Route path="/" element={<Navigate to="/tenants" replace={true} />} />
      </Routes>
    </Suspense>
  );
};
